// extracted by mini-css-extract-plugin
export default {"ToggleArrow":"ToggleArrow_ToggleArrow__n8fZ9","ToggleArrow__triangle":"ToggleArrow_ToggleArrow__triangle__1ka4R","ToggleArrow_opened":"ToggleArrow_ToggleArrow_opened__M4nDM"};